export default {
    agentLoading: state => state.agentLoading,
    agentsListLoading: state => state.agentsListLoading,
    agentsList: state => state.agentsList,
    selectedAgent: state => state.selectedAgent,
}